import React from 'react';

interface TakingOffCloudProps {
  size?: number; // Size of the entire component (circle + icon)
  iconColor?: string;
  backgroundColor?: string;
  strokeWidth?: number;
}

export const TakingOffCloud = ({ 
  size = 40, 
  iconColor = '#14142B',
  backgroundColor = '#F2F4F7',
  strokeWidth = 1.33333 
}: TakingOffCloudProps) => {
  
  return (
    <div 
      style={{ 
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: backgroundColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
          d="M9.33594 15.1667L12.0026 12.5M12.0026 12.5L14.6693 15.1667M12.0026 12.5V18.5M17.3359 15.6619C18.1503 14.9894 18.6693 13.972 18.6693 12.8333C18.6693 10.8083 17.0276 9.16667 15.0026 9.16667C14.8569 9.16667 14.7206 9.09066 14.6467 8.96516C13.7773 7.48989 12.1722 6.5 10.3359 6.5C7.57451 6.5 5.33594 8.73858 5.33594 11.5C5.33594 12.8774 5.8929 14.1247 6.7939 15.029" 
          stroke={iconColor} 
          strokeWidth={strokeWidth} 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

